import { api } from './client';
import type { Lead } from '@/pages/sales/lead-dashboard/leadDomain';

// The Lead Dashboard is backed by Party records (customerType='Lead') plus the
// lead_comm log — the backend maps them into the dashboard's Lead shape.

export interface LeadPayload {
  customer: string;
  category?: string;
  source?: string;
  referralName?: string;
  assignedTo?: string;
  contactNumber?: string;
  email?: string;
  status?: string;
  samplingCostInr?: number;
  valueInr?: number;
  notes?: string;
  date?: string;
  nextFollowUp?: string;
}

export interface CommPayload {
  date: string;
  type: string;
  by?: string;
  note?: string;
}

export async function listLeads(): Promise<Lead[]> {
  const r = await api.get<Lead[]>('/leads');
  return r.data;
}

export async function createLead(payload: LeadPayload): Promise<Lead> {
  const r = await api.post<Lead>('/leads', payload);
  return r.data;
}

export async function updateLead(id: number, payload: LeadPayload): Promise<Lead> {
  const r = await api.patch<Lead>(`/leads/${id}`, payload);
  return r.data;
}

export async function deleteLead(id: number): Promise<void> {
  await api.delete(`/leads/${id}`);
}

export async function addLeadComm(id: number, payload: CommPayload): Promise<Lead> {
  const r = await api.post<Lead>(`/leads/${id}/comms`, payload);
  return r.data;
}

export async function convertLead(id: number, customerType?: string): Promise<Lead> {
  const r = await api.post<Lead>(`/leads/${id}/convert`, { customerType });
  return r.data;
}

// ── Team roster ──
export interface TeamMember {
  id: number;
  name: string;
}

export async function listTeam(): Promise<TeamMember[]> {
  const r = await api.get<TeamMember[]>('/leads/team');
  return r.data;
}

export async function addTeamMember(name: string): Promise<TeamMember> {
  const r = await api.post<TeamMember>('/leads/team', { name });
  return r.data;
}

export async function deleteTeamMember(id: number): Promise<void> {
  await api.delete(`/leads/team/${id}`);
}

/** Backend-generated .xlsx of all leads, for the Export button. */
export function leadsExportPath(): string {
  return '/leads/export.xlsx';
}
